import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react'
import {
    ArchiveBoxIcon,
    ArrowRightCircleIcon,
    ChevronDownIcon,
    DocumentDuplicateIcon,
    EllipsisHorizontalIcon,
    HeartIcon,
    PencilSquareIcon,
    TrashIcon,
    UserPlusIcon,
} from '@heroicons/react/20/solid'
/**
 * @param {Object} groups - An object with keys as group names and values as arrays of items
 * @param {*} param0 
 * @returns 
 */
export default function Dropdown({groups, row}) {
    return (
        <Menu as="div" className="relative inline-block text-left">
            {({ close }) => (
                <>
                    <div className="flex items-center justify-center">
                        <MenuButton 
                            className=""
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex items-center justify-center hover:opacity-50 w-8 h-6">
                                <EllipsisHorizontalIcon />
                            </div>
                        </MenuButton>
                    </div>

                    <MenuItems
                        transition
                        className="absolute right-0 z-[999] mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                        style={{ position: 'fixed', transform: 'translateY(0)' }}
                    >
                        {groups.map((group, index) => (
                            <div className="py-1" key={index}>
                                {group.options.map((item, itemIndex) => (
                                    <a
                                        key={itemIndex}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            item.action(row);
                                            close(); // Close the dropdown after action
                                        }}
                                        className="group flex items-center px-4 py-2 text-sm text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none"
                                    >
                                        {item.icon}
                                        {item.label}
                                    </a>
                                ))}
                            </div>
                        ))}
                    </MenuItems>
                </>
            )}
        </Menu>
    )
}
